module.exports = __webpack_public_path__ + "static/full4-1dc0cd3ce4a69ff706712ec41a1b2206.png";